// extracted by mini-css-extract-plugin
export default {"component":"BookingForm_component__eSgmY","stackable":"BookingForm_stackable__EOS5z","confirmation":"BookingForm_confirmation__IZ8i0"};